module.exports = __webpack_public_path__ + "static/media/amarelo2.8593d0e5.svg";